package top.wcpe.allincore.ui.runtime.ir.call

/**
 * 运行期"部分应用 fun 引用"值（`::name(args)`，M6-e）。
 *
 * 语义：创建时立即对绑定实参求值得到不可变 snapshot；运行期被调用时，把
 * snapshot 实参与本次传入的实参合并（绑定实参在前），转发到目标 screen 级 / 局部 fun。
 * 与 [FunRefValue] 互补：FunRefValue 表示纯引用形态，BoundFunRefValue 表示
 * 至少绑定了一个实参的形态。
 */
data class BoundFunRefValue(
    val name: String,
    private val boundArgsList: List<Any?>,
    private val boundNamedArgsMap: Map<String, Any?>,
) {
    /** 防御式拷贝后的不可变绑定实参列表（实参可为 null：DSL 表达式可求值为 null）。 */
    val boundArgs: List<Any?> get() = boundArgsList

    /** 防御式拷贝后的不可变命名绑定实参映射。 */
    val boundNamedArgs: Map<String, Any?> get() = boundNamedArgsMap

    override fun toString(): String {
        val prefix = "BoundFun(::$name$boundArgsList"
        return if (boundNamedArgsMap.isEmpty()) {
            "$prefix)"
        } else {
            "$prefix,named=$boundNamedArgsMap)"
        }
    }
}
